import ActionTypes from "../constants/action_types";

export default function changeOrganisation() {
  return {
    type: ActionTypes.ORGANISATION_CHANGE.SUCCESS,
  };
}
